import type { FunctionComponent } from 'react';
import { IFieldError } from '../../../../interfaces';
import { FSE_CONTAINER, FSE_MESSAGE } from './fieldErrorTestIds';
import * as styles from './FieldError.module.css';

const FieldError: FunctionComponent<IFieldError> = ({ errorMsg }) => {
  if (!errorMsg) return null;

  return (
    <span data-testid={FSE_CONTAINER} className={styles.feContainer}>
      <span data-testid={FSE_MESSAGE} className={styles.feMessage}>
        {errorMsg}
      </span>
    </span>
  );
};

export default FieldError;
